export default {
  clear() {
    localStorage.clear()
  },
  setItem(key, value) {
    var user = JSON.stringify(value)
    delete user.senha
    localStorage.setItem(key, user)
  },
  getItem(key) {
    return JSON.parse(localStorage.getItem(key))
  },
  removeItem(key) {
    return localStorage.removeItem(key)
  },
  isLogged() {
    return typeof localStorage.getItem('token') === 'string'
  },
  isAdmin() {
    return Number(this.getUser().pro_id) === 1
  },
  isCityUser() {
    return Number(this.getUser().pro_id) === 3
  },
  getUser() {
    var t = localStorage.getItem('user')

    return JSON.parse(localStorage.getItem('user'))
  }
}
